/**
 * 首页路由
 * 2017-12-6
 */
"use strict";
angular.module("pgcManuscriptDetailsRouter", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("pgcmanuscriptdetails", {
        url: "/pgcmanuscriptdetails?articleId&type",
        views: {
            "": {
                template: '<div class="view_head" ui-view="header"></div>' +
                    '<div class="view_body pgcdetailbody">' +
                    '<div class="pgcdetailContent" ui-view="main"></div>' +
                    '</div>'
            },
            "header@pgcmanuscriptdetails": {
                templateUrl: 'header/headerDetails_tpl.html',
                controller: 'webHeaderCtrl'
            },
            "main@pgcmanuscriptdetails": {
                templateUrl: "./main/submissionManage/personalLibrary/pgcManuscriptDetails/pgcManuscriptDetails_tpl.html",
                controller: "pgcManuscriptDetailsCtrl"
            }
        }
    });
}]);